import { Slide, toast, ToastContainer } from "react-toastify";
import approvedIcon from "../../../../assets/icons/approved.svg";
import errorIcon from "../../../../assets/icons/error.svg";

const Toaster = ({ closeToast, title, description, optionNo, optionYes, onClick }) => {
    return (
        <div className="notification">
            <div className="notification-message">
                <p className="notification-message__title">{title}</p>
                <p className="notification-message__description">{description}</p>
            </div>
            <div className="notification-options">
                <div
                    className="notification-options__no"
                    onClick={() => {
                        closeToast();
                    }}
                >
                    <img src={errorIcon}></img>
                    <span className="span-no">{optionNo}</span>
                </div>
                <div className="notification-options__yes" onClick={onClick}>
                    <img src={approvedIcon}></img>
                    <span className="span-yes">{optionYes}</span>
                </div>
            </div>
        </div>
    );
};

export default Toaster;
